import XkAdd from './src/add.vue'

XkAdd.install = function (Vue) {
  Vue.component(XkAdd.name, XkAdd)
}

export default XkAdd



// WEBPACK FOOTER //
// ./src/components/module/add/index.js